export default {
    aa: 'Afar',
    ab: 'Abkhasisk',
    ae: 'Avestisk',
    af: 'Afrikaans',
    ak: 'Akan',
    am: 'Amharisk',
    an: 'Aragonesisk',
    ar: 'Arabisk',
    as: 'Assamesisk',
    av: 'Avarisk',
    ay: 'Aymara',
    az: 'Aserbajdsjansk',
    ba: 'Basjkirsk',
    be: 'Hviterussisk',
    bg: 'Bulgarsk',
    bh: 'Bihari',
    bi: 'Bislama',
    bm: 'Bambara',
    bn: 'Bengali',
    bo: 'Tibetansk',
    br: 'Bretonsk',
    bs: 'Bosnisk',
    ca: 'Katalansk',
    ce: 'Tsjetsjensk',
    ch: 'Chamorro',
    co: 'Korsikansk',
    cr: 'Cree',
    cs: 'Tsjekkisk',
    cu: 'Kirkeslavisk',
    cv: 'Tsjuvasjisk',
    cy: 'Walisisk',
    da: 'Dansk',
    de: 'Tysk',
    dv: 'Dhivehi',
    dz: 'Dzongkha',
    ee: 'Ewe',
    el: 'Gresk',
    en: 'Engelsk',
    eo: 'Esperanto',
    es: 'Spansk',
    et: 'Estisk',
    eu: 'Baskisk',
    fa: 'Persisk',
    ff: 'Fulfulde',
    fi: 'Finsk',
    fj: 'Fijisk',
    fo: 'Færøysk',
    fr: 'Fransk',
    fy: 'Frisisk',
    ga: 'Irsk',
    gd: 'Skotsk gælisk',
    gl: 'Galisisk',
    gn: 'Guaraní',
    gu: 'Gujarati',
    gv: 'Mansk',
    ha: 'Hausa',
    he: 'Hebraisk',
    hi: 'Hindi',
    ho: 'Hiri motu',
    hr: 'Kroatisk',
    ht: 'Haitisk kreolsk',
    hu: 'Ungarsk',
    hy: 'Armensk',
    hz: 'Herero',
    ia: 'Interlingua (International Auxiliary Language Association)',
    id: 'Indonesisk',
    ie: 'Interlingue',
    ig: 'Ibo',
    ii: 'Yi',
    ik: 'Inupiak',
    io: 'Ido',
    is: 'Islandsk',
    it: 'Italiensk',
    iu: 'Inuittisk',
    ja: 'Japansk',
    jv: 'Javanesisk',
    ka: 'Georgisk',
    kg: 'kongo',
    ki: 'kikuya',
    kj: 'Kwanyama',
    kk: 'Kasakhisk',
    kl: 'Grønlandsk',
    km: 'Khmer',
    kn: 'Kannada',
    ko: 'Koreansk',
    kr: 'Kanuri',
    ks: 'Kasjmiri',
    ku: 'Kurdisk',
    kv: 'Syrjensk',
    kw: 'Kornisk',
    ky: 'Kirgisisk',
    la: 'Latin',
    lb: 'Luxembourgsk',
    lg: 'Luganda',
    li: 'Limburgsk',
    ln: 'Lingala',
    lo: 'Laotisk',
    lt: 'Litauisk',
    lu: 'Luba-Katanga',
    lv: 'Latvisk',
    mg: 'Gassisk',
    mh: 'Marshallesisk',
    mi: 'Maorisk',
    mk: 'Makedonsk',
    ml: 'Malayalam',
    mn: 'Mongolsk',
    mo: 'Moldovsk',
    mr: 'Marathi',
    ms: 'Malayisk',
    mt: 'Maltesisk',
    my: 'Burmesisk',
    na: 'Naurisk',
    nb: 'Bokmål',
    nd: 'Nord-ndebele',
    ne: 'Nepali',
    ng: 'Ndonga',
    nl: 'Nederlandsk',
    nn: 'Nynorsk',
    no: 'Norsk',
    nr: 'Sør-ndebele',
    nv: 'Navajo',
    ny: 'Chichewa',
    oc: 'Oksitansk',
    oj: 'Ojibwa',
    om: 'Oromo',
    or: 'Oriya',
    os: 'Ossetisk',
    pa: 'Punjabi',
    pi: 'Pali',
    pl: 'Polsk',
    ps: 'Pashto',
    pt: 'Portugisisk',
    qu: 'Quechua',
    rm: 'Retoromansk',
    rn: 'Kirundi',
    ro: 'Rumensk',
    ru: 'Russisk',
    rw: 'Kinyarwanda',
    sa: 'Sanskrit',
    sc: 'Sardisk',
    sd: 'Sindhi',
    se: 'Nordsamisk',
    sg: 'Sango',
    sh: 'Serbokroatisk',
    si: 'Singalesisk',
    sk: 'Slovakisk',
    sl: 'Slovensk',
    sm: 'Samoansk',
    sn: 'Shona',
    so: 'Somali',
    sq: 'Albansk',
    sr: 'Serbisk',
    ss: 'Swati',
    st: 'Sesotho',
    su: 'Sundanesisk',
    sv: 'Svensk',
    sw: 'Swahili',
    ta: 'Tamilsk',
    te: 'Telugu',
    tg: 'Tadsjikisk',
    th: 'Thai',
    ti: 'Tigrinya',
    tk: 'Turkmensk',
    tl: 'Tagalog',
    tn: 'Tswana',
    to: 'Tonganesisk',
    tr: 'Tyrkisk',
    ts: 'Tsonga',
    tt: 'Tatarisk',
    tw: 'Twi',
    ty: 'Tahitisk',
    ug: 'Uigurisk',
    uk: 'Ukrainsk',
    ur: 'Urdu',
    uz: 'Usbekisk',
    ve: 'Venda',
    vi: 'Vietnamesisk',
    vo: 'Volapük',
    wa: 'Vallonsk',
    wo: 'Wolof',
    xh: 'Xhosa',
    yi: 'Jiddisk',
    yo: 'Joruba',
    za: 'Zhuang',
    zh: 'Kinesisk',
    zu: 'Zulu',
    /**
     * Extended List
     */
    'en-GB': 'English (UK)',
    'es-MX': 'Spansk (Mexico)',
    'pt-BR': 'Brasiliansk portugisisk',
    'zh-TW': 'Tradisjonell kinesisk',
};
